"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subtemplateToMjml = exports.subtemplateToText = void 0;

var subtemplateToMjml = function subtemplateToMjml(item, blockRenderer, isTopLevelNode) {
  if (!item.properties.templateUrn) return '';
  var partialTemplate = "{{> \"".concat(item.properties.templateUrn, "\" ");
  var parameters = item.properties.parameters || {};

  for (var key in parameters) {
    if (parameters[key]) {
      partialTemplate += "".concat(key, "=\"").concat(parameters[key], "\" ");
    }
  }

  return partialTemplate + '}}';
};

exports.subtemplateToMjml = subtemplateToMjml;

var subtemplateToText = function subtemplateToText(item, blockRenderer, isTopLevelNode) {
  if (!item.properties.templateUrn) return '';
  var partialTemplate = "{{> \"".concat(item.properties.templateUrn, "\" ");
  var parameters = item.properties.parameters || {};

  for (var key in parameters) {
    if (parameters[key]) {
      partialTemplate += "".concat(key, "=\"").concat(parameters[key], "\" ");
    }
  }

  return partialTemplate + '}}' + '\r\n';
};

exports.subtemplateToText = subtemplateToText;